import { Icons } from '@components/Icons/Icons';
import type { ReactElement, ReactNode } from 'react';

function CardContainer({ children }: { children: ReactNode }): ReactElement {
  return (
    <div className="mx-auto my-0 max-w-[clamp(350px,500px,100%)] border border-solid border-grey-mid bg-white p-2.5 text-black dark:bg-grey-darkest dark:text-white">
      {children}
    </div>
  );
}

export function ErrorCard({
  title,
  message,
  testid,
}: {
  title: string;
  message: string;
  testid?: string;
}): ReactElement {
  return (
    <CardContainer>
      <h2>{title}</h2>
      <p
        data-testid={testid}
        className="flex items-center justify-evenly gap-4 py-4"
      >
        <span>
          <Icons.Exclamation size="30px" color="red" />
        </span>
        {message}
      </p>
    </CardContainer>
  );
}
